export function normaliseForeignCharacters(input: string): string {
  return (
    input
      .normalize('NFKD')
      // biome-ignore lint/suspicious/noMisleadingCharacterClass: <explanation>
      .replace(/[\u0300-\u036f]/g, '')
  );
}
